// const parentDashboardRoute = "/parent/dashboard";
// const studentMapRoute = "/student/start-your-quest";
// const superAdminRoute = "/admin/dashboard";

/**
 Common Function to Navigate the user after login, So that we don't have to 
 use the same code in multiple places.

 @typedef {import("../hooks/authV2/useGoogleLogin.js").GoogleLoginUser} GoogleLoginUser
 @param {Object} params
 @param {GoogleLoginUser}  params.user -> role of the user
 @param {string}  params.redirect -> redirect url
 @param {string}  params.tab -> tab to be opened
 @param {Function} params.navigate -> navigate function
*/

/**
 * Auth navigation handler
 */

export const authNavigator = ({ user, redirect, tab, navigate }) => {
  const isParent = user?.role_id === 2 || user?.role === 2;
  const isStudent = user?.role_id === 5 || user?.role === 5;
  const isSuperAdmin =
    user?.role_id === 1 ||
    user?.role === 1 ||
    user?.role_id === 14 ||
    user?.role === 14;

  const parentType = user?.parent_type;
  const isSubscribed =
    user?.subscription_data?.is_subscribed ?? user?.is_subscribed ?? false;

  // ================= ROLE PRIORITY =================

  //  Super Admin
  if (isSuperAdmin) {
    localStorage.removeItem("redirectAfterLogin");
    navigate("/admin/dashboard");
    return;
  }

  //  School Parent → Direct to School Parent Dashboard
  if (isParent && parentType === "school_parent") {
    localStorage.removeItem("redirectAfterLogin");
    navigate("/school-parent/dashboard");
    return;
  }

  //  Mixed Parent → Subscribed to /parent/dashboard, otherwise /school-parent/dashboard
  if (isParent && parentType === "mixed") {
    localStorage.removeItem("redirectAfterLogin");
    if (isSubscribed) {
      navigate("/parent/dashboard");
    } else {
      navigate("/school-parent/dashboard");
    }
    return;
  }

  //   Parent subscribed ALWAYS dashboard (ignore redirect)
  if (isParent && isSubscribed) {
    localStorage.removeItem("redirectAfterLogin");
    navigate("/parent/dashboard");
    return;
  }

  // ================= REDIRECT =================

  const stored = localStorage.getItem("redirectAfterLogin");

  if (stored) {
    try {
      const data = JSON.parse(stored);

      if (data?.questId) {
        const redirectIsFree = data?.isFree;

        if (!redirectIsFree && !isSubscribed) {
          navigate("/add-student", { replace: true });
          localStorage.removeItem("redirectAfterLogin");
          return;
        }

        navigate(`/student/admin/episodes/${data.questId}`, {
          replace: true,
        });

        localStorage.removeItem("redirectAfterLogin");
        return;
      }

      if (data?.path) {
        navigate(data.path, { replace: true });
        localStorage.removeItem("redirectAfterLogin");
        return;
      }
    } catch (err) {
      localStorage.removeItem("redirectAfterLogin");
    }
  }

  // ================= ROLE FALLBACK =================

  if (isStudent) {
    navigate("/student/start-your-quest");
    return;
  }

  if (isParent) {
    navigate("/student/start-your-quest");
    return;
  }

  navigate("/student/start-your-quest");
};
